import { c as _c } from "react/compiler-runtime";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { BrandCardHeader } from "../brand/BrandCardHeader";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";
import { LoadingButton } from "../ui/loading-button";
import { StatusMessage } from "../ui/status-message";
import { CheckEmailPanel } from "./CheckEmailPanel";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EmailForm(t0) {
  const $ = _c(21);
  const {
    onEmailSubmit,
    onBackToSignIn,
    loading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      message: "",
      success: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [formState, setFormState] = useState(t1);
  const [email, setEmail] = useState("");
  let t2;
  if ($[1] !== email || $[2] !== onEmailSubmit) {
    t2 = async e => {
      e.preventDefault();
      ;
      try {
        const response = await onEmailSubmit(email);
        setFormState({
          success: response.success,
          message: response.message
        });
      } catch (t3) {
        const error = t3;
        setFormState({
          success: false,
          message: error instanceof Error ? error.message : "An error occurred"
        });
      }
    };
    $[1] = email;
    $[2] = onEmailSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSubmit = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx("label", {
      htmlFor: "email",
      className: "block text-sm font-medium",
      children: "E-post"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => setEmail(e_0.target.value);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== email) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t3, /*#__PURE__*/_jsx(Input, {
        id: "email",
        name: "email",
        type: "email",
        value: email,
        onChange: t4,
        required: true
      })]
    });
    $[6] = email;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== loading) {
    t6 = /*#__PURE__*/_jsx(LoadingButton, {
      type: "submit",
      className: "w-full",
      loading: loading,
      children: "Forts\xE4tt"
    });
    $[8] = loading;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== formState.message || $[11] !== formState.success) {
    t7 = formState.message && /*#__PURE__*/_jsx(StatusMessage, {
      message: formState.message,
      variant: formState.success ? "success" : "error"
    });
    $[10] = formState.message;
    $[11] = formState.success;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onBackToSignIn) {
    t8 = /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "outline",
      className: "w-full",
      onClick: onBackToSignIn,
      children: "Tillbaka till inloggning"
    });
    $[13] = onBackToSignIn;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== handleSubmit || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      className: "space-y-4",
      children: [t5, t6, t7, t8]
    });
    $[15] = handleSubmit;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function PasswordInput(t0) {
  const $ = _c(21);
  const {
    id,
    label,
    value,
    onChange,
    showPassword,
    onTogglePassword
  } = t0;
  let t1;
  if ($[0] !== id || $[1] !== label) {
    t1 = /*#__PURE__*/_jsx("label", {
      htmlFor: id,
      className: "block text-sm font-medium",
      children: label
    });
    $[0] = id;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = showPassword ? "text" : "password";
  let t3;
  if ($[3] !== onChange) {
    t3 = e => onChange(e.target.value);
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== id || $[6] !== t2 || $[7] !== t3 || $[8] !== value) {
    t4 = /*#__PURE__*/_jsx(Input, {
      id: id,
      name: id,
      type: t2,
      value: value,
      onChange: t3,
      required: true
    });
    $[5] = id;
    $[6] = t2;
    $[7] = t3;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== showPassword) {
    t5 = showPassword ? /*#__PURE__*/_jsx(EyeOff, {
      className: "h-4 w-4 text-gray-400"
    }) : /*#__PURE__*/_jsx(Eye, {
      className: "h-4 w-4 text-gray-400"
    });
    $[10] = showPassword;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onTogglePassword || $[13] !== t5) {
    t6 = /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onTogglePassword,
      className: "absolute inset-y-0 right-0 flex items-center pr-3",
      children: t5
    });
    $[12] = onTogglePassword;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [t4, t6]
    });
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t7) {
    t8 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t1, t7]
    });
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function SignUpForm(t0) {
  const $ = _c(87);
  const {
    initialEmail,
    onSignUp,
    onBackToEmail,
    onPrivacyPolicyClick,
    onTermsClick,
    loading,
    statusMessage,
    onStatusMessageAction
  } = t0;
  const [showPassword, setShowPassword] = useState(false);
  let t1;
  if ($[0] !== initialEmail) {
    t1 = {
      email: initialEmail,
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: ""
    };
    $[0] = initialEmail;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [formData, setFormData] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      message: "",
      success: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [formState, setFormState] = useState(t2);
  const [termsAccepted, setTermsAccepted] = useState(false);
  let t3;
  if ($[3] !== formData || $[4] !== termsAccepted) {
    t3 = () => {
      if (!termsAccepted) {
        return {
          success: false,
          message: "Du m\xE5ste acceptera villkoren f\xF6r att forts\xE4tta"
        };
      }
      if (formData.password !== formData.confirmPassword) {
        return {
          success: false,
          message: "L\xF6senorden matchar inte"
        };
      }
      return {
        success: true,
        message: ""
      };
    };
    $[3] = formData;
    $[4] = termsAccepted;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const validateForm = t3;
  let t4;
  if ($[6] !== formData || $[7] !== onSignUp || $[8] !== validateForm) {
    t4 = async e => {
      e.preventDefault();
      const validation = validateForm();
      if (!validation.success) {
        setFormState(validation);
        return;
      }
      ;
      try {
        const {
          ...signUpData
        } = formData;
        const response = await onSignUp(signUpData);
        setFormState({
          success: response.success,
          message: response.message
        });
      } catch (t5) {
        const error = t5;
        setFormState({
          success: false,
          message: error instanceof Error ? error.message : "An error occurred"
        });
      }
    };
    $[6] = formData;
    $[7] = onSignUp;
    $[8] = validateForm;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleSubmit = t4;
  if (statusMessage && onStatusMessageAction) {
    let t5;
    if ($[10] !== statusMessage.message || $[11] !== statusMessage.variant) {
      t5 = /*#__PURE__*/_jsx(StatusMessage, {
        message: statusMessage.message,
        variant: statusMessage.variant
      });
      $[10] = statusMessage.message;
      $[11] = statusMessage.variant;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== onStatusMessageAction) {
      t6 = /*#__PURE__*/_jsx(Button, {
        onClick: onStatusMessageAction,
        className: "w-full",
        children: "Continue"
      });
      $[13] = onStatusMessageAction;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
      t7 = /*#__PURE__*/_jsxs("div", {
        className: "space-y-4",
        children: [t5, t6]
      });
      $[15] = t5;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    return t7;
  }
  let t5;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx("label", {
      htmlFor: "email",
      className: "block text-sm font-medium",
      children: "E-post"
    });
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== formData) {
    t6 = e_0 => setFormData({
      ...formData,
      email: e_0.target.value
    });
    $[19] = formData;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== formData.email || $[22] !== t6) {
    t7 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t5, /*#__PURE__*/_jsx(Input, {
        id: "email",
        name: "email",
        type: "email",
        value: formData.email,
        onChange: t6,
        required: true
      })]
    });
    $[21] = formData.email;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /*#__PURE__*/_jsx("label", {
      htmlFor: "firstName",
      className: "block text-sm font-medium",
      children: "F\xF6rnamn"
    });
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== formData) {
    t9 = e_1 => setFormData({
      ...formData,
      firstName: e_1.target.value
    });
    $[25] = formData;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== formData.firstName || $[28] !== t9) {
    t10 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t8, /*#__PURE__*/_jsx(Input, {
        id: "firstName",
        name: "firstName",
        type: "text",
        value: formData.firstName,
        onChange: t9,
        required: true
      })]
    });
    $[27] = formData.firstName;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = /*#__PURE__*/_jsx("label", {
      htmlFor: "lastName",
      className: "block text-sm font-medium",
      children: "Efternamn"
    });
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== formData) {
    t12 = e_2 => setFormData({
      ...formData,
      lastName: e_2.target.value
    });
    $[31] = formData;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== formData.lastName || $[34] !== t12) {
    t13 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [t11, /*#__PURE__*/_jsx(Input, {
        id: "lastName",
        name: "lastName",
        type: "text",
        value: formData.lastName,
        onChange: t12,
        required: true
      })]
    });
    $[33] = formData.lastName;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t10 || $[37] !== t13) {
    t14 = /*#__PURE__*/_jsxs("div", {
      className: "grid grid-cols-2 gap-4",
      children: [t10, t13]
    });
    $[36] = t10;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== formData) {
    t15 = value => setFormData({
      ...formData,
      password: value
    });
    $[39] = formData;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== showPassword) {
    t16 = () => setShowPassword(!showPassword);
    $[41] = showPassword;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== formData.password || $[44] !== showPassword || $[45] !== t15 || $[46] !== t16) {
    t17 = /*#__PURE__*/_jsx(PasswordInput, {
      id: "password",
      label: "L\xF6senord",
      value: formData.password,
      onChange: t15,
      showPassword: showPassword,
      onTogglePassword: t16
    });
    $[43] = formData.password;
    $[44] = showPassword;
    $[45] = t15;
    $[46] = t16;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== formData) {
    t18 = value_0 => setFormData({
      ...formData,
      confirmPassword: value_0
    });
    $[48] = formData;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== showPassword) {
    t19 = () => setShowPassword(!showPassword);
    $[50] = showPassword;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== formData.confirmPassword || $[53] !== showPassword || $[54] !== t18 || $[55] !== t19) {
    t20 = /*#__PURE__*/_jsx(PasswordInput, {
      id: "confirmPassword",
      label: "Bekr\xE4fta l\xF6senord",
      value: formData.confirmPassword,
      onChange: t18,
      showPassword: showPassword,
      onTogglePassword: t19
    });
    $[52] = formData.confirmPassword;
    $[53] = showPassword;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = checked => setTermsAccepted(checked);
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== termsAccepted) {
    t22 = /*#__PURE__*/_jsx(Checkbox, {
      id: "terms",
      checked: termsAccepted,
      onCheckedChange: t21,
      className: "mt-0.5"
    });
    $[58] = termsAccepted;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== onTermsClick) {
    t23 = /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "text-primary font-medium underline-offset-4 hover:underline",
      onClick: onTermsClick,
      children: "anv\xE4ndarvillkoren"
    });
    $[60] = onTermsClick;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== onPrivacyPolicyClick) {
    t24 = /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "text-primary font-medium underline-offset-4 hover:underline",
      onClick: onPrivacyPolicyClick,
      children: "integritetspolicyn"
    });
    $[62] = onPrivacyPolicyClick;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== t23 || $[65] !== t24) {
    t25 = /*#__PURE__*/_jsxs("label", {
      htmlFor: "terms",
      className: "text-sm text-muted-foreground",
      children: ["Jag har l\xE4st och godk\xE4nner", " ", t23, " ", "och", " ", t24]
    });
    $[64] = t23;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== t22 || $[68] !== t25) {
    t26 = /*#__PURE__*/_jsxs("div", {
      className: "flex items-start space-x-2",
      children: [t22, t25]
    });
    $[67] = t22;
    $[68] = t25;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  let t27;
  if ($[70] !== loading) {
    t27 = /*#__PURE__*/_jsx(LoadingButton, {
      type: "submit",
      className: "w-full",
      loading: loading,
      children: "Skapa konto"
    });
    $[70] = loading;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== formState.message || $[73] !== formState.success) {
    t28 = formState.message && /*#__PURE__*/_jsx(StatusMessage, {
      message: formState.message,
      variant: formState.success ? "success" : "error"
    });
    $[72] = formState.message;
    $[73] = formState.success;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] !== onBackToEmail) {
    t29 = /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "outline",
      className: "w-full",
      onClick: onBackToEmail,
      children: "Tillbaka"
    });
    $[75] = onBackToEmail;
    $[76] = t29;
  } else {
    t29 = $[76];
  }
  let t30;
  if ($[77] !== handleSubmit || $[78] !== t14 || $[79] !== t17 || $[80] !== t20 || $[81] !== t26 || $[82] !== t27 || $[83] !== t28 || $[84] !== t29 || $[85] !== t7) {
    t30 = /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      className: "space-y-4",
      children: [t7, t14, t17, t20, t26, t27, t28, t29]
    });
    $[77] = handleSubmit;
    $[78] = t14;
    $[79] = t17;
    $[80] = t20;
    $[81] = t26;
    $[82] = t27;
    $[83] = t28;
    $[84] = t29;
    $[85] = t7;
    $[86] = t30;
  } else {
    t30 = $[86];
  }
  return t30;
}
export default function SignUpCard(t0) {
  const $ = _c(28);
  const {
    onEmailSubmit,
    onSignUp,
    onBackToSignIn,
    onBackToEmail,
    onPrivacyPolicyClick,
    onTermsClick,
    loading: t1,
    statusMessage,
    onStatusMessageAction,
    onResendVerification,
    onSignUpComplete,
    signUpCompleteLabel
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const [step, setStep] = useState("email");
  const [verifiedEmail, setVerifiedEmail] = useState("");
  let t2;
  if ($[0] !== onEmailSubmit) {
    t2 = async email => {
      const response = await onEmailSubmit(email);
      if (response.success) {
        setVerifiedEmail(email);
        setStep("signup");
      }
      return response;
    };
    $[0] = onEmailSubmit;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleEmailSubmit = t2;
  let t3;
  if ($[2] !== onSignUp) {
    t3 = async formData => {
      const response_0 = await onSignUp(formData);
      if (response_0.success) {
        setVerifiedEmail(formData.email);
        setStep("sent");
      }
      return response_0;
    };
    $[2] = onSignUp;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleSignUp = t3;
  let t4;
  if ($[4] !== onBackToEmail) {
    t4 = () => {
      setStep("email");
      onBackToEmail?.();
    };
    $[4] = onBackToEmail;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleBackToEmail = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      email: {
        title: "Skapa konto",
        subtitle: "Ange din e-postadress f\xF6r att skapa ett konto"
      },
      signup: {
        title: "Fyll i dina uppgifter",
        subtitle: "Fyll i dina personuppgifter f\xF6r att slutf\xF6ra registreringen"
      },
      sent: {
        title: "N\xE4stan klart",
        subtitle: "Ett sista steg innan du kan b\xF6rja"
      }
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const headings = t5[step];
  let t6;
  if ($[7] !== headings.subtitle || $[8] !== headings.title) {
    t6 = /*#__PURE__*/_jsx(BrandCardHeader, {
      title: headings.title,
      subtitle: headings.subtitle
    });
    $[7] = headings.subtitle;
    $[8] = headings.title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleBackToEmail || $[11] !== handleEmailSubmit || $[12] !== handleSignUp || $[13] !== loading || $[14] !== onBackToSignIn || $[15] !== onPrivacyPolicyClick || $[16] !== onResendVerification || $[17] !== onSignUpComplete || $[18] !== onStatusMessageAction || $[19] !== onTermsClick || $[20] !== signUpCompleteLabel || $[21] !== statusMessage || $[22] !== step || $[23] !== verifiedEmail) {
    t7 = /*#__PURE__*/_jsx(CardContent, {
      className: "p-6",
      children: step === "sent" ? /*#__PURE__*/_jsx(CheckEmailPanel, {
        email: verifiedEmail,
        ...(onResendVerification ? {
          onResend: () => onResendVerification(verifiedEmail)
        } : {}),
        onDone: onSignUpComplete ?? onBackToSignIn,
        ...(signUpCompleteLabel ? {
          doneLabel: signUpCompleteLabel
        } : {})
      }) : step === "email" ? /*#__PURE__*/_jsx(EmailForm, {
        onEmailSubmit: handleEmailSubmit,
        onBackToSignIn: onBackToSignIn,
        loading: loading
      }) : /*#__PURE__*/_jsx(SignUpForm, {
        initialEmail: verifiedEmail,
        onSignUp: handleSignUp,
        onBackToEmail: handleBackToEmail,
        onPrivacyPolicyClick: onPrivacyPolicyClick,
        onTermsClick: onTermsClick,
        loading: loading,
        statusMessage: statusMessage,
        onStatusMessageAction: onStatusMessageAction
      })
    });
    $[10] = handleBackToEmail;
    $[11] = handleEmailSubmit;
    $[12] = handleSignUp;
    $[13] = loading;
    $[14] = onBackToSignIn;
    $[15] = onPrivacyPolicyClick;
    $[16] = onResendVerification;
    $[17] = onSignUpComplete;
    $[18] = onStatusMessageAction;
    $[19] = onTermsClick;
    $[20] = signUpCompleteLabel;
    $[21] = statusMessage;
    $[22] = step;
    $[23] = verifiedEmail;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6 || $[26] !== t7) {
    t8 = /*#__PURE__*/_jsxs(Card, {
      className: "bg-card m-auto w-screen overflow-y-auto rounded-none shadow-none sm:max-h-[calc(100vh-112px)] sm:max-w-md sm:rounded-lg sm:shadow-lg sm:shadow-zinc-500/10",
      children: [t6, t7]
    });
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}